import React from "react";

type TextFieldProps = {
    name: string;
    label?: string;
    value?: string;
    placeholder?: string;
    icon?: React.ElementRef<any>;
    onChange?: (value: string) => void;
}

const TextField: React.FC<TextFieldProps> =
    ({
         name,
         label,
         value,
         onChange,
         icon,
         placeholder
     }) => {
        return <>
            <div className="form-label">
                <label htmlFor="">{label}: </label>
            </div>
            <div className="form-control">
                {icon}
                <input
                    type="text"
                    placeholder={placeholder}
                    name={name}
                    id={name}
                    value={value}
                    required
                    onChange={(e) => {
                        onChange && onChange(e.target.value);
                    }}
                />
            </div>
        </>
    }

export default TextField;